module.exports = __webpack_public_path__ + "static/media/contract_change.13381eb0.png";